import { motion, useScroll, useSpring } from 'framer-motion';
import Navigation from './Navigation';
import { useScrollPosition } from '../../hooks/useScrollPosition';

const Header = () => {
  const scrollPosition = useScrollPosition();
  const isScrolled = scrollPosition > 50;

  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    mass: 0.3,
  });

  return (
    <header
      className={`fixed top-0 z-50 w-full transition-all duration-300 ${
        isScrolled ? 'glass-nav shadow-sm' : 'bg-transparent'
      }`}
    >
      <Navigation isScrolled={isScrolled} />
      <motion.div
        className="h-0.5 origin-left bg-gradient-to-r from-brand-500 to-accent-400"
        style={{ scaleX: progress }}
        aria-hidden="true"
      />
    </header>
  );
};

export default Header;
